module.exports = {"id":"dp3_1l3q6","text":"Developing digital content","instructions":"How often do you assess audience needs when creating content?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.1","questionType":"Scale","random":false,"options":[{"id":"dp3_1l3q6-a1","text":"Never","score":2},{"id":"dp3_1l3q6-a2","text":"Rarely","score":2.4},{"id":"dp3_1l3q6-a3","text":"Sometimes","score":3},{"id":"dp3_1l3q6-a4","text":"Often","score":3.6},{"id":"dp3_1l3q6-a5","text":"Always","score":4}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.1/l3q6.json
// module id = 1120
// module chunks = 41